<template>
	<div id="page">
		<Header></Header>

		<div id="searchResults">
			<div class="container">
				<div class="crumbs">
					首页 > 搜索结果
				</div>
				<div class="search_inp">
					<form @submit.prevent="search">
            <input class="text" type="text" placeholder="请输入关键字..." v-model="kw" />
            <input type="submit" class="submit" value=""/>
					</form>
				</div>

				<div class="resultsList">
					<div class="hd">
						<span @click="handleTab('product')" :class="{'active': Tabstatus === 'product'}">产品信息({{ productList.length }})</span>
						<span @click="handleTab('article')" :class="{'active': Tabstatus === 'article'}">新闻中心({{ newsList.length }})</span>
					</div>

					<div class="bd">
						<div class="search-product" v-if="Tabstatus === 'product'">
							<div class="empty" v-if="productList.length === 0">
								<img src="../../static/search-empty.jpg">
							</div>
							<ul v-if="productList.length > 0">
								<li v-for="(item, index) in this.productList">
									<router-link :to="'/product/' + item.product_category + '.html'">
										<div class="img">
											<img :src="imgPrefix + item.product_s_img">
										</div>
									</router-link>
								</li>
							</ul>
						</div>

						<div class="search-article" v-if="Tabstatus === 'article'">
							<div class="empty" v-if="newsList.length === 0">
								<img src="../../static/search-empty.jpg">
							</div>
							<ul v-if="newsList.length > 0">
								<li v-for="(item, index) in this.newsList">
									<router-link :to="'/news/detail-' + item.news_category + '-' + item.id + '.html'">
										<div class="padding">
											<div class="img" v-if="item.news_s_img">
												<img :src="newsImgPrefix + item.news_s_img">
											</div>
											<div class="txt">
												<h2>{{ item.news_title }}</h2>
												<p v-html="item.news_content"></p>
												<div class="time">{{ item.news_display_date }}</div>
											</div>
										</div>
									</router-link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

		</div>

		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';

  import {
    searchProduct,
    searchNews,
    getNewsList,
    getProductList, getProductCategoryList
  } from '../axios/api';

	export default {
		data() {
			return {
				Tabstatus: 'product',
				imgPrefix: process.env.PREFIX_IMG + 'product/',
				newsImgPrefix: process.env.PREFIX_IMG + 'news/',
				kw: this.$route.query.kw ? this.$route.query.kw : '',
				productList: [],
				newsList: [],
			}
		},
		components: {
			Header,
			Footer
		},
    watch: {
      $route() {
        this.kw = this.$route.query.kw ? this.$route.query.kw : '';
        if (this.kw !== '') {
          this.search();
        }
      }
    },
		created() {
			if (this.kw !== '') {
				this.search();
			}
		},
		methods: {
			handleTab(status) {
				this.Tabstatus = status;
			},
			search() {
				if (this.kw !== '') {
					searchProduct({
						sort: 'product_add_date',
						order: 'desc',
						filter_params: {
							'kw': this.kw,
							'product_display': 1
						}
					}).then(response => {
						this.productList = response.data.data.list;
					});
					searchNews({
						filter_params: {
							'kw': this.kw,
							'news_display': 1
						}
					}).then(response => {
						this.newsList = response.data.data.list;
					});
				}
			},
		}
	}
</script>

<style>
	.search-article {
		min-height: 0;
		overflow: hidden;
	}

	.search-article ul li {
		width: 49%;
		float: left;
		background: #fff;
		margin-bottom: 24px;
	}

	.search-article ul li:nth-child(2n) {
		float: right;
	}

	.search-article ul li .padding {
		padding: 28px 25px;
		min-height: 0;
		overflow: hidden;
	}

	.search-article ul li .img {
		float: left;
		margin-right: 25px;
		overflow: hidden;
		width: 273px;
	}

	.search-article ul li .img img {
		transition: all linear 200ms;
		width: 100%;
		height: auto;
		max-height: 185px;
	}

	.search-article ul li .txt h2 {
		font-size: 24px;
		color: #333333;
		line-height: 32px;
		height: 64px;
		margin-bottom: 12px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.search-article ul li .txt .time {
		margin-top: 24px;
		color: #999999;
		font-size: 14px;
	}

	.search-article ul li .txt p {
		font-size: 14px;
		color: #808080;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
		height: 65px;
	}

	.search-article ul li:hover h2 {
		color: #00A0E9;
	}


	.search-product {
		min-height: 0;
		overflow: hidden;
		margin: 30px 0 0 0;
	}

	.search-product ul li {
		width: 24.25%;
		float: left;
		margin-right: 1%;
		margin-bottom: 1%;
	}

	.search-product ul li:nth-child(4n) {
		margin-right: 0;
	}

	.search-product ul li img {
		width: 100%;
		height: auto;
	}

	.empty {
		text-align: center;
		margin: 60px 0 80px 0;
	}

	.resultsList .hd {
		height: 55px;
		border-bottom: 1px solid #c1c1c1;
		text-align: center;
		font-size: 26px;
		color: #666666;
		margin-bottom: 20px;
	}

	.resultsList .hd span {
		margin: 0 45px;
		display: inline-block;
		height: 54px;
		cursor: pointer;
	}

	.resultsList .hd span:hover {
		border-bottom: 2px solid #00a0e9;
		color: #00a0e9;
	}

	.resultsList .hd span.active {
		border-bottom: 2px solid #00a0e9;
		color: #00a0e9;
	}

	#searchResults {
		background: #f4f4f4;
		padding-bottom: 100px;
	}

	#searchResults .crumbs {
		font-size: 14px;
		color: #666666;
		padding-top: 20px;
		margin-bottom: 40px;
	}

	.search_inp {
		width: 680px;
		height: 50px;
		border: 2px solid #e4e4e4;
		margin: auto;
		border-radius: 5px;
		margin-bottom: 50px;
		background-color: #fff;
	}

	.search_inp form{
		height: 100%;
	}

	.search_inp input {
		border: none;
		outline: none;
	}

	.search_inp .text {
		width: 70%;
		height: 100%;
		margin-left: 22px;
	}

	.search_inp .text::placeholder {
		color: #999999;
	}

	.search_inp .submit {
		width: 22px;
		height: 22px;
		background: url(../../static/search2.jpg) no-repeat;
		float: right;
		margin-right: 23px;
		margin-top: 13px;
	}

	@media (max-width:768px) {
		.search_inp {
			width: 100%;
			margin-bottom: 20px;
		}

		.resultsList .hd span {
			font-size: 17px;
			height: 35px;
			margin: 0 15px;
		}

		.resultsList .hd {
			height: 46px;
		}

		#searchResults .crumbs {
			margin-bottom: 20px;
		}

		.empty img {
			width: 250px;
		}

		.search-product ul li {
			width: 49%;
			margin-right: 0;
			margin-bottom: 2%;
		}

		.search-product ul li:nth-child(2n) {
			float: right;
		}

		#searchResults {
			padding-bottom: 50px;
		}

		.search-product {
			margin-top: 20px;
		}

		.search-article ul li .img {
			width: 130px;
			margin-right: 12px;
		}

		.search-article ul li {
			width: 100%;
			margin-bottom: 12px;
		}

		.search-article ul li .txt h2 {
			font-size: 16px;
			line-height: 20px;
			height: 20px;
			margin-bottom: 9px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.search-article ul li .txt p {
			font-size: 12px;
			margin-bottom: 6px;
			height: auto;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			height: 40px;
			line-height: 20px;
		}

		.search-article ul li .txt .time {
			margin-top: 0;
			font-size: 13px;
		}

		.search-article ul li .padding {
			padding: 15px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/search.html.vue